export const selectIsLogged = (state) => Boolean(state.auth.userToken);
